import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { styled, AppText, Flex } from '@streem/ui-react';
import { useRoomSession } from '../../../../context/room_session';
import { useObservable } from '../../../../hooks/rxjs';
export const NetworkSignalLevelLostConnectionText = ({ showNetworkQuality }) => {
    const roomSession = useRoomSession();
    const [remoteNetworkQuality] = useObservable(roomSession.media.remoteNetworkQuality);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    useEffect(() => {
        if (!showNetworkQuality || remoteNetworkQuality !== 0) {
            setShowErrorMessage(false);
        }
        else {
            setShowErrorMessage(true);
        }
    }, [remoteNetworkQuality, showNetworkQuality]);
    return (_jsx(NetworkSignalLevelLostConnectionTextContainer, { children: showErrorMessage && (_jsx(AppText, { "data-testid": "lost-connection-error", as: "p", color: "red50", size: "small", style: { marginLeft: '40px', lineHeight: '18px' }, children: "Lost Connection or Switching Networks" })) }));
};
const NetworkSignalLevelLostConnectionTextContainer = styled(Flex)(() => ({
    height: '18px',
    marginBottom: '20px',
}));
//# sourceMappingURL=network_quality_lost_connection_text.js.map